import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core'
import {CmsOrderDetailOverviewComponent, GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core'
import { OrderDetailsService, OrderOverviewComponent } from '@spartacus/order/components'
import { CmsComponentData } from '@spartacus/storefront'
import {of, Subscription} from 'rxjs'
import { catchError } from 'rxjs/operators'
import {EbAnalyticsService} from "../../../../../analytics/services/facades/eb-analytics.service";

@Component({
    selector: 'eb-order-confirmation-overview',
    templateUrl: './eb-order-confirmation-overview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EbOrderConfirmationOverviewComponent extends OrderOverviewComponent implements OnInit, OnDestroy{

  private orderSubscription: Subscription;

  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected globalMessageService: GlobalMessageService,
    protected translation: TranslationService,
    protected component: CmsComponentData<CmsOrderDetailOverviewComponent>,
    private ebAnalyticsService: EbAnalyticsService
  ) {
    super(translation, orderDetailsService, component)
  }

  ngOnInit() {
    this.orderSubscription = this.order$.pipe(
      catchError(error => {
        this.globalMessageService.add(
          {
            key: 'checkoutProgress.loading.error'
          },
          GlobalMessageType.MSG_TYPE_ERROR
        )
        return of({})
      })
    ).subscribe(
      order => {
        if (order) {
          this.ebAnalyticsService.placeOrder(order);
        }})
  }
  ngOnDestroy() {
    if (this.orderSubscription) {
      this.orderSubscription.unsubscribe();
    }
  }
}
